export const fundDictionary = {
  product_code: 'Sản phẩm',
  fund_code: 'Sản phẩm',
  cert_subscription_amount: 'Vốn mua',
  fund_order_time: 'Thời gian nạp lệnh',
  fund_order_closing_time: 'Thời gian đóng lệnh',
  fund_purchase_date: 'Thời gian quỹ tạo lệnh',
  fund_updated_at: 'Thời gian cập nhật',
  fund_amount: 'Số tiền',
  fund_net_amount: 'Số tiền ròng',
  fund_quantity: 'Số lượng',
  fund_matched_price: 'Giá khớp ',
  fund_fee_amount: 'Phí',
  fund_tax_amount: 'Thuế',
};

export const stockDictionary = {
  stock_symbol: 'Sản phẩm',
  subscription_amount: 'Vốn mua',
};

export const commonDictionary = {
  quantity: 'Số lượng',
  available_quantity: 'SL có thể bán',
  lock_quantity: 'SL chờ bán',
  avg_buy_price: 'Giá mua TB',
  market_value: 'AUM',
  unrealized_gain_loss_amount: 'ROI',
  created_at: 'Created',
  updated_at: 'Updated',
  status: 'Trạng thái',
};
